import { useLocalStorage } from './useLocalStorage'

export function useLocalStorageBackedToggle(key: string): [boolean, (newValue: boolean) => void] {
  const [value, setValue] = useLocalStorage(key + '.local')

  return [value === 'yes', (newValue: boolean) => setValue(newValue ? 'yes' : 'no')]
}
